import { render, staticRenderFns } from "./RangeValuesFlex.vue?vue&type=template&id=3c7a05c8&"
import script from "./RangeValuesFlex.vue?vue&type=script&lang=js&"
export * from "./RangeValuesFlex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports